module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/amex-a4dc274c7ac21232cc49c93313129b8a.png";